import { getIn, useFormikContext } from "formik"
import * as Yup from 'yup'

import { FormikBillingDetails, FormikInspectorAgreeCheck, billingDetailsSchema, FormikNotesArea } from "../../../../../../components/widgets"
import { useEffect } from "react"
import { IWebFileAttachment } from "../../../../../core/applications"

// Site Inspection
export interface IDLMComponentCheck {
  appState: string
  verdict: string
  workflow: string
  note: string
  noteAttachments: Array<IWebFileAttachment>
  inspectorAgree: boolean
}

export const initDLMComponentCheckValues = {
  appState: '',
  verdict: '',
  workflow: '',
  note: '',
  noteAttachments: [],
  inspectorAgree: false,
} 

export const DLMComponentCheckSchema: any = Yup.object({
  appState: Yup.string().trim(),
  verdict: Yup.string().trim(),
  workflow: Yup.string().trim(),
  note: Yup.string().trim().label('Note')
  .when('verdict', {
    is : (verdict: string) => (verdict !== 'approved'),
    then: (schema) => schema.required(),    
  }),  
  inspectorAgree: Yup.bool().label('Confirmation')
    .when('verdict', {
    is : (verdict: string) => (verdict === 'approved'),
    then: (schema) => schema.oneOf([true], 'Must be checked'),    
  }),
  noteAttachments: Yup.array(),

}).concat(billingDetailsSchema);

export const DLMComponentCheckForm = () => {

  const { values, setFieldValue, validateField  } = useFormikContext();

  const verdict = getIn(values, 'verdict') ?? '';
  
  useEffect(() => {
    setFieldValue('billingRequired', (verdict && ['approved','rejected'].includes(verdict)) ? 'YES' : 'NO', true);
    
    validateField('note');
    validateField('inspectorAgree');
        
  }, [verdict, setFieldValue, validateField]);
  
  return (
  <>    
  <FormikBillingDetails />
  
  <FormikNotesArea required={(verdict !== 'approved')} />
  
  { (verdict === 'approved') && 
  <FormikInspectorAgreeCheck />
  }
  </>
  )
}